export const carouselInicio = [
// {
//"imagen":"https://s-gobierno.hidalgo.gob.mx/Img/integridad.gif"
//  }
// ,
//{
//    "imagen": "https://s-gobierno.hidalgo.gob.mx/Img/naranja.gif"
//}
//,
   
   {
    "imagen" : "/assets/imgs/Banner/principal.png"
   }
   ,

   {
    "imagen" : "/assets/imgs/Banner/200.PNG"
    }
    ,
    {
    "imagen" : "/assets/imgs/Banner/Banner3.png"
    }
    ,
    {
    "imagen" : "/assets/imgs/Banner/Banner6.png"
    }
    ,
    {
    "imagen" : "/assets/imgs/Banner/Banner4.png"
    }
    ,
    {
   "imagen" : "/assets/imgs/Banner/Hidalgo.gif"
    } 
]